import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import CMSImage from '../../../Assets/cms/finalIcons/dashboard-c.webp'
import features from '../../../Assets/cms/CMS_features.png'

export default function CMS({toggleOverlay}) {
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);

    return (
        <div className="max-w-6xl mx-auto px-4 py-12 space-y-8 blade-margin-top-sm ">
            <div className="text-center">
                <h3 className="text-center font-gilroy">
                    Charger Management Software
                </h3>
                <p className="leading-normal font-poppins text-center px-5 pt-4 text-base md:text-xl lg:text-2xl">
                    Manage your community EV charging program from one dashboard
                </p>
            </div>

            <div className="bg-grey rounded-3xl p-6 sm:p-10 flex flex-col-reverse md:flex-row items-center justify-between gap-6">
                {/* Text Content */}
                <div className="md:w-1/2 space-y-4 text-center md:text-left">
                    <p className="text-gray-800 font-poppins">
                        Track utilization using the VerdeMobility’s CMS Cloud Dashboard, so you know how and when to
                        scale your solution to meet residents’ EV charging needs.
                    </p>
                    <div className='flex space-x-4'>
                        <div
                            className='mt-5'
                            onClick={toggleOverlay}
                        >
                            <button
                                className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                            >
                                <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                </span>
                                Scheduale a Demo
                            </button>
                        </div>
                        <div
                            className='mt-5'
                            onClick={() => setShowModal(true)}
                        >
                            <button
                                className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                            >
                                <span className="flex justify-center items-center">
                                    <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                    <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                                </span>
                                Features
                            </button>
                        </div>
                    </div>
                </div>

                {/* Image */}
                <div className="md:w-1/2 flex justify-center">
                    <img
                        src={CMSImage}
                        alt="Dashboard Screenshot"
                        className="max-w-full"
                    />
                </div>
            </div>
            {showModal && (
                <div className="fixed !m-0 inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white rounded-2xl p-8 max-w-5xl w-full shadow-xl relative">
                        <button
                            onClick={() => setShowModal(false)}
                            className="absolute top-2 right-4 text-2xl font-bold text-gray-700"
                        >
                            &times;
                        </button>
                        <h2 className="text-xl font-bold mb-4 font-gilroy">Features</h2>
                        <div>
                            <img src={features} alt="features" className='w-full h-full'/>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}
